module.exports = "<a *ngIf=\"!hasChildLevels && hasItem\"\r\n   mat-list-item\r\n   uiSref=\"{{detailsState}}\"\r\n   [uiParams]=\"{id: item.Id}\">\r\n    <ng-container #itemContainer></ng-container>\r\n</a>\r\n<mat-list-item *ngIf=\"!hasItem\"\r\n               [ngStyle]=\"{ 'pointer-events': 'none' }\">\r\n    <i>(No items)</i>\r\n</mat-list-item>\r\n\r\n<ng-container #innerListContainer></ng-container>\r\n\r\n<ng-template #defaultItemTemplate let-itemName>\r\n    {{itemName}}\r\n</ng-template>"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/nested-list-item.component.html
// module id = 1188
// module chunks = 1